import React, {useEffect} from "react";
import { Route, Routes } from "react-router-dom";
import Series from "../layout/series/Series";
import AddSeries from "../layout/series/AddSeries";
function SeriesPage() {
    useEffect(() => {
        return() =>{
            localStorage.removeItem("selectedId")
            localStorage.removeItem("itemOffset")
            localStorage.removeItem("forcePage")
        }
    }, []);
  return (
    <>
      <Routes>
        <Route path="/" element={<Series />} />
        <Route path="/add" element={<AddSeries />} />
        <Route path="/update/:id" element={<AddSeries />} />
      </Routes>
    </>
  );
}

export default SeriesPage;
